import * as React from "react";
import { FeatureToggle as FeatureToggleEnum } from "../../domain";
import { useEffectAfterMount } from "../hooks";
interface FeatureToggleProps {
    children?: React.ReactNode;
    feature: FeatureToggleEnum;
}
const FeatureToggleContext = React.createContext<{
    isFeatureOn?: boolean;
}>(undefined);

const useFeatureToggleContext = () => {
    const ctx = React.useContext(FeatureToggleContext);
    if (!ctx) {
        throw new Error(
            "feature toggle components cannot be rendered outside of the FeatureToggle component"
        );
    }
    return ctx;
};

export const FeatureToggle = (props: FeatureToggleProps) => {
    const { feature, children } = props;
    const value = React.useMemo(() => ({ isFeatureOn: feature.isEnabled }), [
        feature,
    ]);

    return (
        <FeatureToggleContext.Provider value={value}>
            {children}
        </FeatureToggleContext.Provider>
    );
};

const FeatureToggleOn = (props: { children: React.ReactNode }) => {
    const { isFeatureOn } = useFeatureToggleContext();
    if (isFeatureOn === undefined) return null;
    return <>{isFeatureOn ? props.children : null}</>;
};

const FeatureToggleOff = (props: { children: React.ReactNode }) => {
    const { isFeatureOn } = useFeatureToggleContext();
    if (isFeatureOn === undefined) return null;
    return <>{isFeatureOn ? null : props.children}</>;
};

FeatureToggle.On = FeatureToggleOn;
FeatureToggle.Off = FeatureToggleOff;
